import React, { useMemo } from 'react';
import { Css, IDropdownItem, ISelectProps, Omit, Responsive } from '@/ui';
import styled from '@emotion/styled';
import { SelectInput } from '../../../../components/common/select/SelectInput';
import { IJobEntry } from '../../../../contentful/types/IJob';

interface IEmployerSelectProps
	extends Omit<ISelectProps, 'items' | 'onChange'> {
	jobs: IJobEntry[];
	value?: string;
	onChange?: (value?: string) => void;
}

const defaultItem: IDropdownItem = {
	value: '',
	stringValue: 'All companies',
};

export const EmployerSelect = ({
	jobs,
	value,
	onChange,
	...rest
}: IEmployerSelectProps) => {
	const items: IDropdownItem[] = useMemo(() => {
		const employerNames = jobs.map((job) => job.fields.employerName);
		const employerItems = [...new Set(employerNames)].map((name) => ({
			value: name,
			stringValue: name,
		}));

		return [defaultItem, ...employerItems];
	}, [jobs]);

	const handleOnChange = (item: IDropdownItem | null) => {
		const newValue = item
			? typeof item === 'string'
				? item
				: item.value
			: undefined;
		onChange?.(newValue);
	};

	return (
		<StyledSelectInput
			placeholder="Company"
			items={items}
			onChange={handleOnChange}
			initialSelectedItem={value ?? defaultItem.stringValue}
			{...rest}
		/>
	);
};

const StyledSelectInput = styled(SelectInput)`
	max-width: ${Css.pxToRem(200)};
	width: 100%;

	& div[type='button'] div {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		max-width: 100%;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: 100%;
	}
`;
